/** Copy of the replen page (Operations), ported from VentaHub. */
export const replen = {
  title: 'Replen management',
  description:
    'Whether each SKU is reordered at a warehouse, and whether it is a focus SKU. Vendor orders need both.',
  chooseTitle: 'Choose a warehouse',
  chooseHint: 'A SKU’s replen class is set per warehouse.',
  empty: 'No SKUs to show',
  emptyHint:
    'Only SKUs with a vendor cost at this warehouse can be set up. Nothing else matches these filters.',
  filters: {
    warehouse: 'Warehouse',
    choose: 'Choose…',
    skus: 'SKU codes',
    text: 'SKU code or name',
    brand: 'Brand',
    category: 'Category',
    retailerSkus: 'Retailer SKUs',
    class: 'Replen class',
    focus: 'Focus',
  },
  classes: {
    R: 'R · Replenish',
    N: 'N · Stop buying',
    T: 'T · Temporarily replenish',
  },
  noClass: 'Not set',
  count_one: '{{formatted}} SKU',
  count_other: '{{formatted}} SKUs',
  focusYes: 'Focus',
  focusNo: 'Not focus',
  classFor: 'Replen class for {{code}}',
  focusFor: 'Focus for {{code}}',
  focusLocked: 'Focus stays on while this SKU has stock here.',
  mixed: 'Mixed',
  mixedHint: 'Its {{count}} vendor cost rows disagree; saving sets them all to one class.',
  missingCost:
    'No vendor cost at this warehouse for {{codes}}, so there is nothing to set yet: upload a vendor cost first.',
  unknown: 'Not SKUs: {{codes}}.',
  unsaved_one: '{{count}} SKU changed, not saved yet',
  unsaved_other: '{{count}} SKUs changed, not saved yet',
  discard: 'Discard',
  save: 'Save changes',
  saved_one: '{{count}} SKU saved',
  saved_other: '{{count}} SKUs saved',
  // Taking a stopped (N) SKU back needs someone else's approval on a ticket.
  pendingApproval_one:
    '{{count}} SKU was stopped, so its change waits for approval on ticket #{{ticket}}. Someone other than you accepts it there.',
  pendingApproval_other:
    '{{count}} SKUs were stopped, so their changes wait for approval on ticket #{{ticket}}. Someone other than you accepts it there.',
  columns: {
    sku: 'SKU',
    brand: 'Brand',
    category: 'Category',
    available: 'Available',
    class: 'Replen class',
    focus: 'Focus',
  },
  bulkUpload: {
    button: 'Bulk upload',
    template: 'Template',
    cannotRead: 'Could not read the file.',
    empty: 'Nothing was staged from that file.',
    staged_one: '{{count}} SKU staged from the file — review, then Save changes.',
    staged_other: '{{count}} SKUs staged from the file — review, then Save changes.',
    reasons: {
      empty: 'Neither a new replen class nor a new focus flag was given.',
      badClass: '"{{value}}" is not a replen class — use R, N or T.',
      badFocus: '"{{value}}" is not a focus flag — use Y or N.',
      missingCost: 'No vendor cost at this warehouse — upload one, then try again.',
      unknown: 'Not a SKU code.',
    },
    rejections: {
      title_one: '{{count}} row from the file was not staged',
      title_other: '{{count}} rows from the file were not staged',
      hint: 'Everything else from the sheet is staged in the grid — review it and press Save changes. These rows were left out; fix them in the sheet and upload again.',
      download: 'Download',
      close: 'Close',
    },
  },
} as const
